import { render } from "./detailReadonly.vue?vue&type=template&id=6d966a85&scoped=true"
import script from "./detailReadonly.vue?vue&type=script&lang=js"
export * from "./detailReadonly.vue?vue&type=script&lang=js"

import "./detailReadonly.vue?vue&type=style&index=0&id=6d966a85&lang=scss"
import "./detailReadonly.vue?vue&type=style&index=1&id=6d966a85&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d966a85"]])

export default __exports__